<template>
    <dialog-modal v-if="shouldRender" :show="show" type="danger" @close="closeModal" @submit="closeModal">
        <template #title>{{ trans('assets.overview.scanner.error.inoperable_test_blocked_title') }}</template>
        {{ trans('assets.overview.scanner.error.inoperable_test_blocked') }}
        <template #footer>
            <jet-button variant="primary" style="flex: 1" @click.stop="closeModal">
                {{ trans('general.action.close') }}
            </jet-button>
        </template>
    </dialog-modal>
</template>
<script setup>
import DialogModal from '@/Jetstream/DialogModal.vue';
import JetButton from '@/Jetstream/Button.vue';
import { eventBus, events } from '@/eventBus.js';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';

const shouldRender = ref(false);
const show = ref(false);

onMounted(() => {
    eventBus.$on([events.openInoperableTestBlockedModal], () => {
        shouldRender.value = true;

        nextTick(() => {
            show.value = true;
        });
    });
});

onUnmounted(() => {
    eventBus.$off([events.openInoperableTestBlockedModal]);
});

const closeModal = () => {
    show.value = false;
    setTimeout(() => {
        shouldRender.value = false;
    }, 300);
};
</script>
